export const shipsSerials={
    // 'FAKEPLC-1':'FAKEPLC',
    'STSY-T-FANTASIA':'FANTASIA',
    'SV-T-9248734':'MEGALOXARI',
    'SV-T-ARIADNE':'ARIADNE',
    'SV-T-EP-CONSOLES':'CONSOLES',
    'SV-T-EP-CONSUMPTION':'CONSUMPTION',
    'SV-T-EXSKIATHOS':'IOLKOS',
    'SV-T-P12215-HZ-GPU7':'GENERATORS',
}